module.exports = __webpack_public_path__ + "assets/202509252035/img/organizationStructure.0e0ed5f8.png";